import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Beauty } from "./Beauty/Beauty";
import { Confectionary } from "./Confectionary/Confectionary";
import { WineAndSpirits } from "./WineAndSpirits/WineAndSpirits";
import { Fashion } from "./Fashion/Fashion";
import { FoodAndBeverages } from "./FoodAndBeverages/FoodAndBeverages";
import { Others } from "./Others/Others";
import { Promotions } from "./Promotions/Promotions";
import { CategoryBanner } from "./CategoryBanner/CategoryBanner";
import { EditTopHeader } from "./TopHeader/EditTopHeader";
import { MenuHeader } from "./MenuHeader/MenuHeader";

export const Header = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const activeTab = query.get('activeTab');

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/header?activeTab=topHeader`, {
        replace: true,
      });
    }
  }, []);

  const items = [
    {
      label: "Top Header",
      key: "topHeader",
      children: <EditTopHeader />,
    },
    // {
    //   label: "Menu Header",
    //   key: "menuHeader",
    //   children: <MenuHeader />,
    // },
    {
      label: "Category Banner",
      key: "categoryBanner",
      children: <CategoryBanner />,
    },
  ];

  return (
    <ContentWrapper title={"Header"}>
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
